/* eslint-disable no-restricted-globals */

import { colorForGeneric, colorForTaxaAplicada } from "./colorUtils";

/* const criaArrayPoligonos = (shpData, dbfData, coluna) => {
    console.log("CriaArrayPoligonos");
    const arrayPoligonos = []; // Use um array vazio, não [null]
    if (!shpData || shpData.record.length === 0) {
        return [];
    }
    for (let i = 0; i < shpData.record.length; i++) {
        const poligono = createPolygon();
        // ... (sua lógica completa de cálculo e atribuição de cor)
        for (let j = 0; j < shpData.record[i].points.length; j++) {
            const point = createPointLatLng(
                shpData.record[i].points[j].x,
                shpData.record[i].points[j].y
            );
            poligono.points[j] = point;
        }
        poligono.data = dbfData.records[coluna].data[i];
        if (poligono.data === 0) poligono.rgb = "#7f7f7f";
        else {
            const amplitude = dbfData.limites[coluna].limiteMax - dbfData.limites[coluna].limiteMin;
            const fator = ((poligono.data - dbfData.limites[coluna].limiteMin) * 2) / amplitude;
            if (fator < 1) {
                const arredondado = Math.floor(fator * 255);
                poligono.rgb = rgbToHex(255, arredondado, 0);
            } else {
                const arredondado = Math.floor(255 - (fator - 1) * 255);
                poligono.rgb = rgbToHex(arredondado, 255, 0);
            }
        }
        arrayPoligonos.push(poligono);
    }
    return arrayPoligonos;
}; */

/* const criaArrayPoligonosTaxaAplicada = (shpData, dbfData) => {    
    console.log("CriaArrayPoligonosTaxaAplicada");
    const arrayPoligonos = [];
    if (!shpData || shpData.record.length === 0) return [];
    console.log("CriaArrayPoligonosTaxaAplicada dbfData = ", dbfData);
    const colunaAplicado = 0;
    const colunaPrescricao = 1;

    // limites para prescrito
    const minPrescrito = dbfData.limites[colunaPrescricao].limiteMin;
    const maxPrescrito = dbfData.limites[colunaPrescricao].limiteMax;

    // também precisamos do maior valor real aplicado (para o gradiente acima)
    const valoresAplicados = dbfData.records[colunaAplicado].data;
    const maxAplicado = Math.max(...valoresAplicados);

    for (let i = 0; i < shpData.record.length; i++) {
        const poligono = createPolygon();

        // coordenadas
        poligono.points = shpData.record[i].points.map(pt =>
            createPointLatLng(pt.x, pt.y)
        );

        const valorAplicado = valoresAplicados[i];
        const valorPrescrito = dbfData.records[colunaPrescricao].data[i];

        poligono.data = valorAplicado;

        // === Atribui cor ===
        if (valorAplicado === 0) {
            poligono.rgb = "#7f7f7f"; // cinza para zerado
        } else if (valorAplicado < minPrescrito) {
            // Gradiente de cinza (0) até vermelho (minPrescrito)
            const fator = valorAplicado / minPrescrito; // 0..1
            const r = Math.floor(127 + fator * (255 - 127));
            const g = Math.floor(127 - fator * 127);
            const b = Math.floor(127 - fator * 127);
            poligono.rgb = rgbToHex(r, g, b);
        } else if (valorAplicado > maxPrescrito) {
            // Gradiente de verde (maxPrescrito) até azul (maxAplicado)
            const fator = (valorAplicado - maxPrescrito) / (maxAplicado - maxPrescrito); // 0..1
            const r = 0;
            const g = Math.floor(255 - fator * 255); // 255→0
            const b = Math.floor(fator * 255);       // 0→255
            poligono.rgb = rgbToHex(r, g, b);
        } else {
            // Dentro da faixa prescrita → gradiente vermelho→amarelo→verde
            const fator = (valorAplicado - minPrescrito) / (maxPrescrito - minPrescrito); // 0..1
            let r, g, b;

            if (fator <= 0.5) {
                // Interpola de vermelho (#FF0000) → amarelo (#FFFF00)
                const t = fator / 0.5; // reescala 0..0.5 → 0..1
                r = 255;
                g = Math.floor(255 * t); // 0 → 255
                b = 0;
            } else {
                // Interpola de amarelo (#FFFF00) → verde (#00FF00)
                const t = (fator - 0.5) / 0.5; // reescala 0.5..1 → 0..1
                r = Math.floor(255 * (1 - t)); // 255 → 0
                g = 255;
                b = 0;
            }

            poligono.rgb = rgbToHex(r, g, b);
            }

        arrayPoligonos.push(poligono);
    }

    return arrayPoligonos;
}; */


// --- Função unificada ---
export function criaArrayPoligonosUnificado(shpData, dbfData, coluna) {
  if (!shpData || shpData.record.length === 0) return [];

  const arrayPoligonos = [];
  let min = dbfData.limites[coluna].limiteMin;
  let max = dbfData.limites[coluna].limiteMax;

  const colAplicado = 0;
//   let colPrescrito = 1;
//   if (dbfData.qtdOfRecords === 1)
//       colPrescrito = 0;
  const valoresAplicados = dbfData.records[colAplicado].data;
//   const valoresPrescritos = dbfData.records[colPrescrito].data;
//   const maxAplicado = Math.max(...valoresAplicados);


  for (let i = 0; i < shpData.record.length; i++) {
    const poligono = createPolygon();

    const pontos = shpData.record[i].points;
    poligono.points = pontos.slice(0,-1).map(pt =>
      createPointLatLng(pt.x, pt.y)
    );

    const valor = dbfData.records[coluna].data[i];
    poligono.data = valor;

    // if (coluna === colAplicado) {
    //     min = dbfData.limites[colPrescrito].limiteMin;
    //     max = dbfData.limites[colPrescrito].limiteMax;
    //     poligono.rgb = colorForTaxaAplicada(valor, min, max, maxAplicado);
    // } else {
      poligono.rgb = colorForGeneric(valor, min, max);
    // }

    arrayPoligonos.push(poligono);
  }

  return arrayPoligonos;
}


/* export function criaArrayPoligonosUnificadoFundido(shpData, dbfData, coluna, tolerancia = 0) {
  if (!shpData || !shpData.record || shpData.record.length === 0) return [];

  const arrayPoligonos = [];
  let min = dbfData.limites[coluna].limiteMin;
  let max = dbfData.limites[coluna].limiteMax;

  const colAplicado = 0;
  const colPrescrito = 1;
  const valoresAplicados = dbfData.records[colAplicado].data;
  const maxAplicado = Math.max(...valoresAplicados);


//   const fundeValor = (a, b, tolerancia) => Math.abs(a - b) <= tolerancia; //valor absoluto
    const fundeValor = (a, b, tolerancia = 0) => {
        // ex: perc = 0.05 → 5%
        const perc = tolerancia / 100;
        const ref = Math.max(Math.abs(a), Math.abs(b), 1); // evita divisão por zero
        return Math.abs(a - b) / ref <= perc;
    };

  const pontosIguais = (p1, p2) => p1.lat === p2.lat && p1.lng === p2.lng;

  const compartilhaDoisPontos = (poly1, poly2) => {
    let iguais = 0;
    for (const pt1 of poly1) {
      for (const pt2 of poly2) {
        if (pontosIguais(pt1, pt2)) iguais++;
        if (iguais >= 2) return true;
      }
    }
    return false;
  };

  let cobra = null;
  let valorAnterior = null;
  let coordsAnterior = null;

  const fecharCobra = () => {
    if (!cobra) return;
    const poly = createPolygon();
    poly.points = [cobra.head, cobra.td1, ...cobra.dd, ...cobra.de];
    poly.data = cobra.data;
    poly.rgb = cobra.rgb;
    arrayPoligonos.push(poly);
    cobra = null;
  };

  for (let i = 0; i < shpData.record.length; i++) {
    // quadrado original: [TE, TD, DD, DE, TE]
    const pts = shpData.record[i].points;
    const TE = createPointLatLng(pts[0].x, pts[0].y);
    const DE = createPointLatLng(pts[1].x, pts[1].y);
    const DD = createPointLatLng(pts[2].x, pts[2].y);
    const TD = createPointLatLng(pts[3].x, pts[3].y);

    const coords = [TE, TD, DD, DE];
    const valor = dbfData.records[coluna].data[i];

    if (!cobra) {
      const rgb = (coluna === colAplicado)
        ? colorForTaxaAplicada(
            valor,
            dbfData.limites[colPrescrito].limiteMin,
            dbfData.limites[colPrescrito].limiteMax,
            maxAplicado
          )
        : colorForGeneric(valor, min, max);

      cobra = { head: TE, td1: TD, dd: [DD], de: [DE], data: valor, rgb };
      valorAnterior = valor;
      coordsAnterior = coords;
      continue;
    }

    if (fundeValor(valorAnterior, valor, tolerancia) && compartilhaDoisPontos(coordsAnterior, coords)) {
      // funde na barriga
      cobra.dd.push(DD);
      cobra.de.unshift(DE);
    } else {
      // fecha a cobra atual
      fecharCobra();

      const rgb = (coluna === colAplicado)
        ? colorForTaxaAplicada(
            valor,
            dbfData.limites[colPrescrito].limiteMin,
            dbfData.limites[colPrescrito].limiteMax,
            maxAplicado
          )
        : colorForGeneric(valor, min, max);

      cobra = { head: TE, td1: TD, dd: [DD], de: [DE], data: valor, rgb };
    }

    valorAnterior = valor;
    coordsAnterior = coords;
  }

  fecharCobra();
  return arrayPoligonos;
} */
export function criaArrayPoligonosUnificadoFundido(
  shpData,
  dbfData,
  coluna,
  tolerancia = 0,
  limiteFusao = 300 // 🔥 NOVO
) {
  if (!shpData || !shpData.record || shpData.record.length === 0) return [];

  const arrayPoligonos = [];
  let min = dbfData.limites[coluna].limiteMin;
  let max = dbfData.limites[coluna].limiteMax;

  const colAplicado = 0;
  const colPrescrito = 1;
  const valoresAplicados = dbfData.records[colAplicado].data;
  //const maxAplicado = Math.max(...valoresAplicados);
  const maxAplicado = valoresAplicados.reduce(
    (max, v) => (v != null && v > max ? v : max),
    -Infinity
  );

  // 🔒 FAIL-SAFE
  let iteracoes = 0;
  const MAX_ITERACOES = shpData.record.length * 2;

  // ⚡ CACHE DE PONTOS
  const cachePontos = new Map();
  const getPoint = (x, y) => {
    const key = (x * 1e6 | 0) * 1000000 + (y * 1e6 | 0);
    if (cachePontos.has(key)) return cachePontos.get(key);

    const p = createPointLatLng(x, y);
    cachePontos.set(key, p);
    return p;
  };

  const fundeValor = (a, b, tolerancia = 0) => {
    if (a == null || b == null) return false;

    const perc = tolerancia / 100;
    const ref = Math.max(Math.abs(a), Math.abs(b), 1);
    return Math.abs(a - b) / ref <= perc;
  };

  // ⚡ chave numérica (rápida)
  const pontoKey = (p) => (p.lat * 1e6 | 0) * 1000000 + (p.lng * 1e6 | 0);

  const compartilhaDoisPontos = (poly1, poly2) => {
    const set = new Set(poly1.map(pontoKey));
    let iguais = 0;

    for (const pt of poly2) {
      if (set.has(pontoKey(pt))) {
        iguais++;
        if (iguais >= 2) return true;
      }
    }
    return false;
  };

  let cobra = null;
  let valorAnterior = null;
  let coordsAnterior = null;
  let tamanhoCobra = 0; // 🔥 controle de tamanho

  const fecharCobra = () => {
    if (!cobra) return;

    const poly = createPolygon();
    poly.points = [
      cobra.head,
      cobra.td1,
      ...cobra.dd,
      ...cobra.de.reverse() // ⚡ só inverte aqui
    ];
    poly.data = cobra.data;
    poly.rgb = cobra.rgb;

    arrayPoligonos.push(poly);
    cobra = null;
    tamanhoCobra = 0;
  };

  for (let i = 0; i < shpData.record.length; i++) {

    // 🔒 proteção
    iteracoes++;
    if (iteracoes > MAX_ITERACOES) {
      console.warn("Loop protegido: excesso de iterações detectado");
      break;
    }

    const rec = shpData.record[i];
    if (!rec || !rec.points || rec.points.length < 4) continue;

    const pts = rec.points;

    const TE = getPoint(pts[0].x, pts[0].y);
    const DE = getPoint(pts[1].x, pts[1].y);
    const DD = getPoint(pts[2].x, pts[2].y);
    const TD = getPoint(pts[3].x, pts[3].y);

    const coords = [TE, TD, DD, DE];

    let valor = dbfData.records[coluna].data[i];
    if (valor == null || isNaN(valor)) continue;

    if (!cobra) {
      const rgb = (coluna === colAplicado)
        ? colorForTaxaAplicada(
            valor,
            dbfData.limites[colPrescrito].limiteMin,
            dbfData.limites[colPrescrito].limiteMax,
            maxAplicado
          )
        : colorForGeneric(valor, min, max);

      cobra = { head: TE, td1: TD, dd: [DD], de: [DE], data: valor, rgb };
      valorAnterior = valor;
      coordsAnterior = coords;
      tamanhoCobra = 1;
      continue;
    }

    // 🔥 NOVA REGRA: limite de fusão
    if (tamanhoCobra >= limiteFusao) {
      fecharCobra();

      const rgb = (coluna === colAplicado)
        ? colorForTaxaAplicada(
            valor,
            dbfData.limites[colPrescrito].limiteMin,
            dbfData.limites[colPrescrito].limiteMax,
            maxAplicado
          )
        : colorForGeneric(valor, min, max);

      cobra = { head: TE, td1: TD, dd: [DD], de: [DE], data: valor, rgb };
      valorAnterior = valor;
      coordsAnterior = coords;
      tamanhoCobra = 1;
      continue;
    }

    if (
      fundeValor(valorAnterior, valor, tolerancia) &&
      compartilhaDoisPontos(coordsAnterior, coords)
    ) {
      // funde
      cobra.dd.push(DD);
      cobra.de.push(DE); // ⚡ substitui unshift
      tamanhoCobra++;

    } else {
      fecharCobra();

      const rgb = (coluna === colAplicado)
        ? colorForTaxaAplicada(
            valor,
            dbfData.limites[colPrescrito].limiteMin,
            dbfData.limites[colPrescrito].limiteMax,
            maxAplicado
          )
        : colorForGeneric(valor, min, max);

      cobra = { head: TE, td1: TD, dd: [DD], de: [DE], data: valor, rgb };
      tamanhoCobra = 1;
    }

    valorAnterior = valor;
    coordsAnterior = coords;
  }

  fecharCobra();

  return arrayPoligonos;
}

function createPolygon() {
  return {
    points: [null],
    data: null,
    rgb: "",
  };
}

function createPointLatLng(x, y) {
  return {
    lat: y,
    lng: x,
  };
}

/* function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}*/

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function ShxReader(array) {    
    var dataview1 = new DataView(array, 0, array.length);
    let contentLength = dataview1.getInt32(24, false);
    let polyCount = (contentLength - 50) / 4;  
    const shxData = createShxObject(contentLength, polyCount);

    // console.log("shxData ", shxData, " com ", polyCount, " poligonos");

    for (let i = 0; i < polyCount; i++) {
        let offset = dataview1.getInt32(100 + i * 8, false);
        let length = dataview1.getInt32(104 + i * 8, false);
        shxData.polygonsIndex[i] = createShxPoligonIndex(offset, length)
    }
    return shxData;
}

function createShxObject(contentLength, polyCount) {
    return {
        contentLength,
        polyCount,
        polygonsIndex: [null]
    }
}

function createShxPoligonIndex(index, length) {
    return {
        index: index,
        length: length
    }
}

function ShpReader(array, shxData) {
    var dataview = new DataView(array, 0, array.length);
    const fileLenght = dataview.getInt32(24, false);
    const shpData = createShpObject(fileLenght);
    shpData.boxXmin = dataview.getFloat64(36, true);
    shpData.boxYmin = dataview.getFloat64(44, true);
    shpData.boxXmax = dataview.getFloat64(52, true);
    shpData.boxYmax = dataview.getFloat64(60, true);
    /*ShapeFile Header
    console.log("dataview1 = ", dataview1);
    console.log("FileCode = ", dataview1.getInt32(0, false));
    console.log("FileLenght = ", dataview1.getInt32(24, false));
    console.log("Version = ", dataview1.getInt32(28, true));
    console.log("ShapeType = ", dataview1.getInt32(32, true));
    console.log("BBoxXmin = ", dataview1.getFloat64(36, true));
    console.log("BBoxYmin = ", dataview1.getFloat64(44, true));
    console.log("BBoxXmax = ", dataview1.getFloat64(52, true));
    console.log("BBoxYmax = ", dataview1.getFloat64(60, true));*/
    //Começa o loop de poligonos
    for (let i = 0; i < shxData.polyCount; i++) {
        const shpRecord = createShpRecord();
        const recordIndex = shxData.polygonsIndex[i].index * 2;
        shpRecord.recordNumber = dataview.getInt32(recordIndex, false);
        shpRecord.contentLength = dataview.getInt32(recordIndex + 4, false);
        shpRecord.shapeType = dataview.getInt32(recordIndex + 8, true);
        shpRecord.boxXmin = dataview.getFloat64(recordIndex + 12, true);
        shpRecord.boxYmin = dataview.getFloat64(recordIndex + 20, true);
        shpRecord.boxXmax = dataview.getFloat64(recordIndex + 28, true);
        shpRecord.boxYmax = dataview.getFloat64(recordIndex + 36, true);
        shpRecord.numParts = dataview.getInt32(recordIndex + 44, true);
        shpRecord.numPoints = dataview.getInt32(recordIndex + 48, true);
        for (let j=0; j < shpRecord.numParts; j++) {
            shpRecord.parts[j] = dataview.getInt32(recordIndex + 52 + j * 4, true);
        }
        for (let j=0; j < shpRecord.numPoints; j++) {
            const x = dataview.getFloat64(recordIndex + 52 + 4 * shpRecord.numParts + j * 16, true);
            const y = dataview.getFloat64(recordIndex + 60 + 4 * shpRecord.numParts + j * 16, true);
            shpRecord.points[j] = createPoint(x, y);
        }
        shpData.record[i] = shpRecord;
    }
    //Record header
    // console.log("array: ", array, "dataview: ", dataview);

    return shpData;
}

function createShpObject(fileLenght) {
    return {
        fileLenght,
        boxXmin: null,
        boxYmin: null,
        boxXmax: null,
        boxYmax: null,
        record: [null]
    }
}

function createShpRecord() {
    return {
        recordNumber: null,
        contentLength: null,
        shapeType: null,
        boxXmin: null,
        boxYmin: null,
        boxXmax: null,
        boxYmax: null,
        numParts: null,
        numPoints: null,
        parts: [null],
        points: [null]
    }
}

function createPoint(x, y) {
    return {
        x,
        y
    }
}

function DbfReader(array) {
    var byteArray = new Uint8Array(array);
    var dataview1 = new DataView(array, 0, array.length);
    let numberOfRecords = dataview1.getInt32(4, true);
    let numberOfBytesHeader = dataview1.getInt16(8, true);
    let numberOfBytesRecord = dataview1.getInt16(10, true);
    let qtdOfRecords = (numberOfBytesHeader - 1 - 32) / 32;
    const dbfData = createDbfObject(numberOfRecords, numberOfBytesHeader, numberOfBytesRecord, qtdOfRecords);
    for (let i = 0; i < qtdOfRecords; i++) {
        //createRecord
        let nomeArray = new Uint8Array([
            byteArray[32 + i * 32],
            byteArray[33 + i * 32],
            byteArray[34 + i * 32],
            byteArray[35 + i * 32],
            byteArray[36 + i * 32],
            byteArray[37 + i * 32],
            byteArray[38 + i * 32],
            byteArray[39 + i * 32],
            byteArray[40 + i * 32],
            byteArray[41 + i * 32],
            byteArray[42 + i * 32]
        ]);
        let decoder = new TextDecoder("utf-8");
        let nome = decoder.decode(nomeArray);
        let fieldLength = dataview1.getInt8(32 + 16 + i * 32);
        let fieldDecimalCount = dataview1.getInt8(32 + 17 + i * 32);
        dbfData.records[i] = createDbfRecord(i, nome, fieldLength, fieldDecimalCount);
        dbfData.limites[i] = createLimites(100_000, 0);
    }
    // Agora examina as linhas
    let indexAux = numberOfBytesHeader; //position of first data record
    for (let i = 0; i < numberOfRecords; i++)
    {
        indexAux++; //mais um espaço inicial "deletion flag"
        for (let j = 0; j < qtdOfRecords; j++)
        {
            let dadosArray = new Uint8Array(dbfData.records[j].fieldLength);
            //console.log("length do field = ", dbfData.records[j].fieldLenght);
            for (let k = 0; k < dbfData.records[j].fieldLength; k++)
            {
                dadosArray[k] = byteArray[indexAux];
                indexAux++;
            }
            let decoder = new TextDecoder("utf-8");
            let dado = decoder.decode(dadosArray);
            let valor = parseFloat(dado);
            //console.log("valor = ", valor);
            if (j === 2)
              valor *= 3.6;
            dbfData.records[j].data[i] = valor;
            if (valor < dbfData.limites[j].limiteMin) {
                // if (j === 1)
                //     console.log("novo mínimo = ", valor);
                if (j === 1) { //Se for a coluna de prescrição, não salva o valor mínimo de zero pois é quando está fora do mapa
                    if (valor !== 0)                        
                        dbfData.limites[j].limiteMin = valor;
                } 
                else {
                    dbfData.limites[j].limiteMin = valor;
                }
            }
            if (valor > dbfData.limites[j].limiteMax)
                dbfData.limites[j].limiteMax = valor;
            /*byte[] arrayParcial = new byte[fieldLength[j]];
            Array.Copy(dadosdbf, indexAux, arrayParcial, 0, fieldLength[j]);
            indexAux += fieldLength[j];
            string recordFieldASCII = System.Text.Encoding.Default.GetString(arrayParcial);
            //Debug.Log($"Record[{i}]: Coluna[{j}] = {recordFieldASCII}");
            if (j == indexPrescricao)
            {
                recordFieldASCII = recordFieldASCII.Replace(',', '.');
                recordFieldASCII = recordFieldASCII.Replace('*', '0');
                float prescricao = 0f;
                try
                {
                    prescricao = float.Parse(recordFieldASCII);
                    if (prescricao > maxPrescript) maxPrescript = prescricao;
                    if ((prescricao < minPrescription) && (prescricao > 0)) minPrescription = prescricao;
                }
                catch { }
                prescription.Add(prescricao);
            }*/
        }
    }
    // console.log("dbfData = ", dbfData);
    return dbfData;
}

function createDbfObject (numOfRecords, numOfBytesHeader, numOfBytesRecord, qtdOfRecords) {
    return {
        numOfRecords,
        numOfBytesHeader,
        numOfBytesRecord,
        qtdOfRecords,
        limites: [null],
        records: [null]
    }
}

function createDbfRecord(index, nomeColuna, fieldLength, fieldDecimalCount) {
    return {
        index,
        nomeColuna,
        fieldLength,
        fieldDecimalCount,
        data: [null]
    }
}

function createLimites (min, max) {
    return {
        limiteMax: max,
        limiteMin: min
    }
}

// A sua função organizaShape() também deve vir para cá
export const organizaShape = (shpBinary, shxBinary, dbfBinary) => {
  // ... a sua lógica para organizar os dados
  const shx = ShxReader(shxBinary);
  const shpObj = ShpReader(shpBinary, shx);
  const dbfObj = DbfReader(dbfBinary);
  // console.log("Funcao organizaShape shp=", shpObj, ", dbfData=", dbfObj);
  return { shpObj, dbfObj };
  
    /* const shxData = ShxReader(shxBinary);
    setShxData(shxData);
    setShpData(ShpReader(shpBinary, shxData));
    setDbfData(DbfReader(dbfBinary)); */
};

// Esta é a parte principal do Web Worker
/* addEventListener('message', (e) => {
  const { shpBinary, shxBinary, dbfBinary, coluna } = e.data;

  try {
    // Roda a sua lógica de processamento em segundo plano
    const { shpData, dbfData } = organizaShape(shpBinary, shxBinary, dbfBinary);
    const poligonosCompletos = criaArrayPoligonos(shpData, dbfData, coluna);

    postMessage({ status: 'success', data: poligonosCompletos });
  } catch (error) {
    postMessage({ status: 'error', message: error.message });
  }
}); */
/* addEventListener('message', (e) => {
    const { shpBinary, shxBinary, dbfBinary, coluna, shpData, dbfData } = e.data;
    
    // Passo 1: Verifique se os dados binários foram recebidos corretamente
    try {
      console.log("Fazendo o work de organizar o shape");

      if (!shpData) {
        // Passo 2: Verifique se a função organizaShape retorna dados válidos
      const { shpData, dbfData } = organizaShape(shpBinary, shxBinary, dbfBinary);
      }
      
      // O problema está aqui. Verifique se dbfData não é nulo ou undefined.
      // É provável que este log mostre 'undefined'.
      console.log('Worker: Resultado de organizaShape. dbfData:', dbfData);
      
      const poligonosCompletos = criaArrayPoligonosUnificado(shpData, dbfData, coluna);
      
      postMessage({ status: 'success', data: poligonosCompletos, shpDataE: shpData, dbfDataE: dbfData });
    } catch (error) {
        postMessage({ status: 'error', message: error.message });
    }
}); */

/* addEventListener('message', (e) => {
  const { shpBinary, shxBinary, dbfBinary, coluna, shpData, dbfData } = e.data;
  console.log("AddEvent no worker com shpBinary = ", shpBinary, ", shxBinary=", shxBinary, ", dbfBinary=", dbfBinary, ", coluna=", coluna, ", shpData=", shpData, ", dbfData=", dbfData)

  // Passo 1: Verifique se os dados binários foram recebidos corretamente
  // console.log('Worker: Dados recebidos. shpBinary length:', shpBinary.byteLength);

  try {
    var shpObj, dbfObj;
    if (!shpData) {
      console.log("Dentro do try, com !shpData");
      // Passo 2: Verifique se a função organizaShape retorna dados válidos
      let { shp, dbf } = organizaShape(shpBinary, shxBinary, dbfBinary);
      console.log("Retorno organizaShape shp=", shp, ", dbf=", dbf);
      shpObj = shp;
      dbfObj = dbf;
    }
    else {
      console.log("Dentro do try com shpData");
      shpObj = shpData;
      dbfObj = dbfData;
    }

    console.log('shpObj=', shpObj, ", dbfObj=", dbfObj);

    const poligonosCompletos = criaArrayPoligonosUnificado(shpObj, dbfObj, coluna);

    console.log("Resultado do criaArrayPoligonos = ", poligonosCompletos);

    if (!shpData) {
      console.log("post worker com !shpData");
      postMessage({ status: 'success', data: poligonosCompletos, shpObj, dbfObj });
    }
    else{
      console.log("post worker com shpData");
      postMessage({ status: 'success', data: poligonosCompletos});
    }
  } catch (error) {
    postMessage({ status: 'error', message: error.message });
  }
}); */